import React, {useState, useEffect, useRef} from 'react';
import usePopupAnimation from '../utils/usePopupAnimation.js';

export default function Timer({show, close, defaultValue, returnValue, useCurrentTime}) {
	const popupAnimationMs = 300;
	const [value, setValue] = useState('');
	const hourRefs = useRef({});
	const minuteRefs = useRef({});
	const {shouldRender, isClosing} = usePopupAnimation(show, popupAnimationMs);

	useEffect(() => {
		var newVal = defaultValue;

		if ((defaultValue === '' || defaultValue === '00:00' || defaultValue === '0:0') && useCurrentTime) {
			let hours = new Date().getHours();
			let minutes = new Date().getMinutes();

			if (hours.toString().length === 1) {
				hours = '0' + hours;
			}

			if (minutes.toString().length === 1) {
				minutes = '0' + minutes;
			}

			newVal = hours + ':' + minutes;
		}

		setValue(newVal);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [show]);

	useEffect(() => {
		if (!show || !value.includes(':')) {
			return;
		}

		const [selectedHour, selectedMinute] = value.split(':');
		const selectedHourElement = hourRefs.current[selectedHour];
		const selectedMinuteElement = minuteRefs.current[selectedMinute];

		if (selectedHourElement) {
			selectedHourElement.scrollIntoView({block: 'center'});
		}

		if (selectedMinuteElement) {
			selectedMinuteElement.scrollIntoView({block: 'center'});
		}
	}, [show, value]);

	const hours = [];
	const minutes = [];

	for (let i = 0; i < 24; i++) {
		let val = i.toString();

		if (val.length === 1) {
			val = '0' + val;
		}

		hours.push(val);
	}

	for (let i = 0; i < 60; i++) {
		let val = i.toString();

		if (val.length === 1) {
			val = '0' + val;
		}

		minutes.push(val);
	}

	return (
		<>
			{shouldRender ? (
				<div className={`popup${isClosing ? ' popup--closing' : ''}`} onClick={() => { close(); }} style={{zIndex: '2000'}}>
					<div className={`popup_content${isClosing ? ' popup_content--closing' : ''}`} style={{width: 'min(calc(95% - 1.9rem), 71.25rem)'}} onClick={(e) => e.stopPropagation()}>
						<div className="popup_content_in_body">
							<div className="popup_content_in_body_in" style={{padding: '1rem 1rem 0rem 1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center'}}>
								{value}
							</div>

							<div className="popup_content_in_body_in" style={{padding: '0rem 1rem 0rem 1rem', justifyContent: 'center', alignItems: 'center', textAlign: 'center'}}>
								<div className="zero h1" />
								<div className="fl_l timer" style={{width: '48%', height: '20rem'}}>
									{hours.map((item, index) => (
										<div
											className={`list_new gray cr_p ${item === value.split(':')[0] ? 'green' : ''}`}
											key={index}
											ref={(element) => {
												hourRefs.current[item] = element;
											}}
											onClick={() => setValue(item + ':' + value.split(':')[1])}
										>
											<div className="list_new_head fnt_b">
												{item}
											</div>
										</div>
									))}
								</div>
								<div className="fl_r timer" style={{width: '48%', height: '20rem'}}>
									{minutes.map((item, index) => (
										<div
											className={`list_new gray cr_p ${item === value.split(':')[1] ? 'green' : ''}`}
											key={index}
											ref={(element) => {
												minuteRefs.current[item] = element;
											}}
											onClick={() => setValue(value.split(':')[0] + ':' + item)}
										>
											<div className="list_new_head fnt_b">
												{item}
											</div>
										</div>
									))}
								</div>
								<div className="zero h1" />
							</div>
							<div className="popup_content_in_foot">
								<div className="popup_content_in_foot_in">
									<button
										type="button"
										className="button green mr_1"
										onClick={() => {
											returnValue(value);
											close();
										}}
									>
										Vybrat
									</button>

									<button
										type="button"
										className="button"
										onClick={() => {
											close();
										}}
									>
										Zpět
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			) : (
				''
			)}
		</>
	);
}
